import React from 'react';
import Navbar from '../gral-components/Navbar';
import Profile from './components/Profile';
import JobRequest from './components/JobRequest';
import TalentRequest from './components/TalentRequest';
import PostBlog from './components/PostBlog';
import SettingAccount from './components/SettingAccount';
import HelpAccount from './components/HelpAccount';

import users from '../data/users/users-profile.json';

import './stylesheets/account.scss';



class Account extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accountOn: false,
      navbarElementClicked: 'profile',
      email: localStorage.getItem('email'),
      userImage: '',
      personalInfo: {
        firstname: '',
        lastname: '',
        talent: '',
        location: '',
        availability: '',
        workTime: '',
        description: ''
      },
      update: false
    };
  };
  componentDidMount = () => {
    this.updateState();
    this.setState({ accountOn: true })
  };
  componentWillUnmount = () => {
    this.setState({ accountOn: false })
  };
  componentDidUpdate = () => {
    if (this.state.update) {
      this.updateState();
      this.setState({ update: false })  
    }
  };
  updateState = () => {
    let personalInfo = JSON.parse(localStorage.getItem('personalInfo'));
    let userImage = localStorage.getItem('userImage');
    this.setState({
      userImage: userImage ? userImage : '',
      personalInfo: {
        firstname: personalInfo ? personalInfo.firstname : 'Firstname',
        lastname: personalInfo ? personalInfo.lastname : 'Lastname',
        talent: personalInfo ? personalInfo.talent : 'Your talent',
        location: personalInfo ? personalInfo.location : 'City, Country',
        availability: personalInfo ? personalInfo.availability : 'Your availability',
        workTime: personalInfo ? personalInfo.workTime : 'workTime',
        description: personalInfo ? personalInfo.description : 'Your personal description'
      }
    });
  };
  updateHandle = () => {
    this.setState({ update: true })
  };
  navbarClickHandle = (e) => {
    let event = e.currentTarget.dataset.value;
    if (event === 'profile' || event === 'job-request' ||
      event === 'talent-request' || event === 'post-blog' ||
      event === 'setting' || event === 'help') {
      this.setState({
        navbarElementClicked: event
      });
    }
  };

  render() {
    let userCurrent = users.talent.professional.filter((user) => user.userID === 'llane100579');
    let navbarElementClicked = this.state.navbarElementClicked;
    let navbarElementRendered =
      navbarElementClicked === 'profile' ?
        <Profile
          email={this.state.email}
          userImage={this.state.userImage}
          personalInfo={this.state.personalInfo}
          updateHandle={this.updateHandle}
          dataUser={userCurrent}
        />
        : navbarElementClicked === 'job-request' ?
          <JobRequest />
          : navbarElementClicked === 'talent-request' ?
            <TalentRequest />
            : navbarElementClicked === 'post-blog' ?
              <PostBlog />
              : navbarElementClicked === 'setting' ?
                <SettingAccount />
                : navbarElementClicked === 'help' ?
                  <HelpAccount />
                  : '';

    return (
      <div className='background-gradient-image' >
        <div className='account-section' >
          <div className='account-header'>
            <Navbar
              accountOn={this.state.accountOn}
              navbarClickHandle={(e) => { this.navbarClickHandle(e) }}
              navbarElementClicked={this.state.navbarElementClicked}
              firstname={this.state.personalInfo.firstname}
              navbarType='account'
            />
          </div>
          <div className='account-container'>
            <div className='account-content'>
              <div className='account-content-container'>
                {navbarElementRendered}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default Account;